export default {
  teacher: 'Teacher',
  student: 'Student',
  guardian: 'Guardian',
}
